<ng-container *ngFor="let data_ of $any(data)">
  <mat-accordion>
    <mat-expansion-panel [expanded]="step === 0">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ data_.title }}
          <p *ngIf="data_.unit" style="font-size: 12px">{{ data_.unit }}</p>
        </mat-panel-title>
        <mat-panel-description> </mat-panel-description>
      </mat-expansion-panel-header>

      <div *ngFor="let row of data_.row">
        <div class="row">
          <div *ngFor="let col of row.col" class="col-4">
            <usimweb-form-input [value]="col.value" [placeholder]="col.placeholder" [readonly]="true">
            </usimweb-form-input>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</ng-container>
